// extracted by mini-css-extract-plugin
export default {"container":"Loading-module__container--fc340","dot":"Loading-module__dot--c8bca","pulse":"Loading-module__pulse--add63"};